import { Col, message, Row } from "antd";
import { useHistory } from "react-router";
import { useEffect, useRef, useState } from "react";

import "./gradeMapTable.less";
import Table from "@components/Table";
import Button from "@components/Button";
import {
  useDownloadGradeTableQuery,
  useFetchAllGradeCompaniesQuery,
  useFetchTARanksQuery,
  useUploadGradeTableMutation,
} from "@services";
import { IGradeCompany } from "@types";
import { checkPermission, getRows } from "@utils";
import { paths, permissions } from "@router";
import customErrorMessage from "@/components/CustomErrorMessage";
import { handleCsvUpload } from "@/utils/uploadCsv";

const default_cols = [
  {
    title: <div className="text-wrap">ta rank</div>,
    dataIndex: "rank",
    key: "taRank",
    width: 300,
  },
];

const GradeMapTable = () => {
  const history = useHistory();
  const inputRef = useRef<any>(null);
  const tableRef = useRef<any>(null);
  const [download, setDownload] = useState(false);
  const [tableHeight, setTableHeight] = useState(0);
  const [uploadGradeTable, { isLoading: isUploading }] =
    useUploadGradeTableMutation();
  const { isLoading: isDownloading } = useDownloadGradeTableQuery(null, {
    skip: !download,
  });
  const { data: taRanksData, error } = useFetchTARanksQuery(null);
  const { data: taRanks } = taRanksData || {};
  const {
    data: companiesData,
    isLoading: isLoadingCompanies,
    error: companiesError,
  } = useFetchAllGradeCompaniesQuery(null);
  const { data: companies } = companiesData || {};

  const handleTableCell = (e: any) => {
    const id = e.currentTarget.dataset.id;
    const grade_company = companies.find(
      (company: IGradeCompany) => +company?.id === +id
    );
    history.push(paths.admin.settings.grade_map_table.edit_grade_company, {
      grade_company: {
        ...grade_company,
        grade_company_ranks: grade_company?.grade_company_ranks,
      },
    });
  };

  const additional_cols: any =
    (!error &&
      companies?.map((company: IGradeCompany) => ({
        title: (
          <div
            className="grade__header__row__btn text-wrap"
            data-id={company.id}
            onClick={() => {}}
            // onClick={handleTableCell}
          >
            {company.name}
          </div>
        ),
        dataIndex: company.name.replace(/\s/g, ""),
        key: company.id,
        width: 300,
      }))) ||
    [];
  const columns = [...default_cols, ...additional_cols];

  const rows =
    !error && !companiesError && companies?.length && taRanks?.length
      ? getRows(taRanks, companies)
      : [];

  const handleAddBtn = () => {
    history.push(paths.admin.settings.grade_map_table.create_grade_company);
  };

  useEffect(() => {
    const TabTop = tableRef.current.getBoundingClientRect();
    setTableHeight(window.innerHeight - TabTop.top - 100);
  }, []);

  return (
    <>
      {/* <div className="appTitle text-base font-[500] mx-5">
        Companies Grade Map Table
      </div> */}
      <div className="bg-white p-4 sm:p-5">
        <div className="jobCreationBar  sticky top-0 z-10 bg-themeCore px-14 py-6 rounded-lg flex justify-between items-center mb-7">
          <div className="title text-white font-[500] text-3xl uppercase">
            Companies Grade Map Table
          </div>

          {checkPermission(permissions.CREATE_COMPANY_USER) && (
            <div className="action-buttons flex items-center gap-2">
              <input
                id="myInput"
                type="file"
                ref={inputRef}
                hidden={true}
                onChange={e => handleCsvUpload(e, uploadGradeTable)}
                accept=".csv,text/csv"
              />

              <Button
                isLoading={isUploading}
                variant="buttonWhite"
                onClick={() => inputRef?.current?.click()}
              >
                Upload Grade Map
              </Button>

              <Button
                variant="buttonWhite"
                onClick={() => setDownload(true)}
                isLoading={isDownloading}
              >
                Download Grade Map
              </Button>

              <Button
                variant="buttonWhite"
                icon={false}
                onClick={() =>
                  history.push(
                    paths.admin.settings.grade_map_table.edit_grade_company
                  )
                }
              >
                Add / Edit
              </Button>
            </div>
          )}
        </div>

        <div className="jobCreationListing rounded-lg">
          <div ref={tableRef} style={{ width: "100%", overflowX: "auto" }}>
            <Table
              scroll={400}
              data={rows}
              columns={columns}
              pagination={false}
              isLoading={isLoadingCompanies}
              splitLastColumn={false}
            />
          </div>
        </div>
      </div>
    </>
  );
};
export default GradeMapTable;
